import { api } from '@/plugins/api'

const getDefaultState = () => {
  return {
    langues: [],
  }
}

const state = getDefaultState()

const getters = {
  getLangues: (state) => {
    return state.langues
  },
}

const mutations = {
  setLangues (state, langues) {
    state.langues = langues ?? []
  },
  setLangueId (state, payload) {
    payload.element.id = payload.id
  },
  addLangue (state, langue) {
    state.langues.push(langue)
  },
  removeLangue (state, langue) {
    state.langues.splice(state.langues.indexOf(langue), 1)
  },
  majLangue (state, langue) {
    state.langues[state.langues.indexOf(state.langues.find(a => a.id == langue.id))] = langue
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async fetchLangueByContactId ({ commit }, contactId) {
    const response = await api.get(`langue/contacts/` + contactId)
    commit("setLangues", response.data)
  },
  async fetchLangueByDemandeAdmissionId ({ commit }, demandeAdmissionId) {
    const response = await api.get(`langue/demandesadmissions/` + demandeAdmissionId)
    commit("setLangues", response.data)
  },
  async fetchLangueByDemandeInscriptionId ({ commit }, demandeInscriptionId) {
    const response = await api.get(`langue/demandesinscriptions/` + demandeInscriptionId)
    commit("setLangues", response.data)
  },
  async createLangue ({ state, commit }, langue) {
    const response = await api.post(`langue`, langue)

    if (response.data) {
      commit("setLangueId", { element: langue, id: response.data })
    }
  },
  async updateLangue ({ commit }, langue) {
    const response = await api.put(`langue`, langue)
    commit("majLangue", response.data)
  },
  async deleteLangue ({ commit }, langue) {
    const response = await api.delete(`langue/` + langue.id)

    if (response.data == true) {
      commit("removeLangue", langue)
    }
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
})